import { Component, Input, OnInit, OnDestroy, SecurityContext } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { ReleaseNotesService } from 'app/shared/services-api-central/release-notes/release-notes.service';
import { takeUntil } from 'rxjs/operators';
import { ReleaseNote } from 'app/shared/services-api-central/release-notes/release-notes.interface';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  standalone: false,
})
export class ReleaseNotesComponent implements OnInit, OnDestroy {
  @Input() smallView: boolean = false;

  private unsubscriber = new ReplaySubject();
  public releaseNotes: ReleaseNote[];
  public theme$: Observable<EThemeName>;
  public readonly notesDefaultUrl: string = 'https://mysoftware.dnv.com/download/public/greenpowermonitor/gpm-horizon-wind/gpm-horizon-wind.html';

  constructor(
    private releaseNotesService: ReleaseNotesService,
    private themeService: ThemeService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.theme$ = this.themeService.getTheme();
    this.releaseNotesService.notes$.pipe(takeUntil(this.unsubscriber)).subscribe((notes) => {
      this.releaseNotes = notes;
    });
  }

  public closeReleaseNotes() {
    this.releaseNotesService.close();
  }

  public ngOnDestroy(): void {
    if (this.unsubscriber) {
      this.unsubscriber.unsubscribe();
    }
  }
}
